"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toPressReleaseListSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toPressReleaseListSlice = function (data, logger) {
    var _a;
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.PressReleaseList)), { title: fields_1.toText((_a = data.primary) === null || _a === void 0 ? void 0 : _a.section_title), cta: field_groups_1.toCta(utils_1.unprefix('section', data.primary), logger) }));
};
exports.toPressReleaseListSlice = toPressReleaseListSlice;
//# sourceMappingURL=press-release-list-slice.js.map